
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import SectionLayout from '@/components/SectionLayout.vue';
  import BackgroundImage from '@/components/BackgroundImage.vue';

  @Component({
    components: {
      SectionLayout,
      BackgroundImage
    },
  })
  export default class AuthPage extends Vue {
  }
